import React, {Component} from 'react'
import {message} from 'antd'
import DepositsApi from '../../../api/Sales/Deposits'
import Deposits from './Deposits'
import {pick} from 'lodash'

class DepositsCont extends Component {
  state = {
    list: [],
    transaction: {},
    receipt: {},
    fetching: false,
  }
  api = new DepositsApi()

  componentDidMount() {
    this.fetch()
  }

  fetch = async () => {
    try {
      this.setState({
        fetching: true,
      })
      const list = await this.api.list()
      this.setState({
        fetching: false,
        list,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({fetching: false})
    }
  }

  render() {
    return <Deposits {...this.state} {...pick(this, ['fetch'])} />
  }
}

DepositsCont.propTypes = {}
DepositsCont.defaultProps = {}

export default DepositsCont
